// NgRX
import { createReducer, on } from '@ngrx/store';
import { DepreciationFourthStepEffectsActions, DepreciationSecondStepEffectsActions,
  DepreciationThirdStepEffectsActions } from '../actions/depreciation.actions';
import { WarrantyRecoveryEffectsActions } from '../actions/warranty.actions';

// Models
import { AutoPayCase, ExcelStatus, Warranty } from '@core/models/warranty.interface';
import { MaintainerUsersEffectsActions } from '@core/store/actions/maintainer.actions';



export const initialState: Warranty = {
  recovery: {
    total: 0,
    contracts: [ ],
    excelStatus: ExcelStatus.UNTRIGGED,
    selectors: {
      centers: [ ],
      cases: [ ],
    },
    autoPayCases: { },
    error: ''
  }
};


export const warrantyReducer = createReducer(
  initialState,
  on(WarrantyRecoveryEffectsActions.injectError, (_state, { error }) => {
    console.warn({ error })
    return ({
      ..._state,
      recovery: {
        ..._state.recovery,
        error,
      },
  })}),
  on(WarrantyRecoveryEffectsActions.injectContractsTableSelectors, (_state, { selectors }) => {
    console.log({ selectors });
    return ({ ..._state, recovery: { ..._state.recovery, selectors }});
  }),
  on(WarrantyRecoveryEffectsActions.injectContracts, (_state, { contracts, total }) => ({
    ..._state,
    recovery: {
      ..._state.recovery,
      contracts,
      total,
      excelStatus: ExcelStatus.UNTRIGGED,
      error: ''
    },
  })),
  on(WarrantyRecoveryEffectsActions.contractsFailedExport, _state => ({
    ..._state,
    recovery: {
      ..._state.recovery,
      excelStatus: ExcelStatus.FAILED,
      error: 'Error al intentar exportar a Excel'
    },
  })),
  on(WarrantyRecoveryEffectsActions.contractsSuccessfullyExported, _state => ({
    ..._state,
    recovery: {
      ..._state.recovery,
      excelStatus: ExcelStatus.SUCCESSFUL,
      error: ''
    },
  })),
  on(WarrantyRecoveryEffectsActions.injectAutoPayCases, (_state, { autoPayCases }) => ({
    ..._state,
    recovery: {
      ..._state.recovery,
      autoPayCases,
    },
  })),
);
